import { render, staticRenderFns } from "./proof-view-sidebar-right.vue?vue&type=template&id=924f163a&scoped=true&"
import script from "./proof-view-sidebar-right.vue?vue&type=script&lang=js&"
export * from "./proof-view-sidebar-right.vue?vue&type=script&lang=js&"
import style0 from "./proof-view-sidebar-right.vue?vue&type=style&index=0&id=924f163a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924f163a",
  null
  
)

export default component.exports